/**
 * @generated SignedSource<<845327f21021300e258831cae3906c84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LiveReactions_viewer$data = {
  readonly account: {
    readonly id: string;
  };
  readonly settings: {
    readonly enableLiveReactions: boolean | null;
  };
  readonly " $fragmentType": "LiveReactions_viewer";
};
export type LiveReactions_viewer$key = {
  readonly " $data"?: LiveReactions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LiveReactions_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LiveReactions_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableLiveReactions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9c445380395bee3e47ee4f0a125a6391";

export default node;
